/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import Cookies from 'js-cookie';
import ReactLoading from 'react-loading';
import InfiniteScroll from 'react-infinite-scroller';
import api from 'api';
import { FormControlLabel, Checkbox } from '@mui/material';
import { Header, SideMenuBroker, PolicyItem, Search, Button, Dialog, Select } from 'components';
import { Container, ContentArea, Title, Div, DataArea, LoadingArea, CountArea, ModalButton } from './styles';
import { loadingColor, primary, white } from 'styles/colorProvider';
import { TiFilter } from 'react-icons/ti';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { toast } from 'react-toastify';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ptBR } from 'date-fns/locale';

const MAX_DATE_RANGE_DAYS = 31;

const validateDateRange = (startStr, endStr) => {
  if (!startStr || !endStr || startStr.length < 10 || endStr.length < 10) return { valid: true };
  const start = moment(startStr, 'DD/MM/YYYY', true);
  const end = moment(endStr, 'DD/MM/YYYY', true);
  if (!start.isValid()) return { valid: false, error: 'Data inicial inválida. Use DD/MM/AAAA.' };
  if (!end.isValid()) return { valid: false, error: 'Data final inválida. Use DD/MM/AAAA.' };
  if (end.isBefore(start)) return { valid: false, error: 'A data final deve ser igual ou posterior à data inicial.' };
  if (end.diff(start, 'days') > MAX_DATE_RANGE_DAYS) {
    return { valid: false, error: `O intervalo não pode ser maior que ${MAX_DATE_RANGE_DAYS} dias (1 mês).` };
  }
  return { valid: true };
};

function Policies() {
  const scrollParent = useRef();

  const [loading, setLoading] = useState(false);
  const [policiesList, setPoliciesList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [hasNextPage, setHasNextPage] = useState();
  const [search, setSearch] = useState();
  const [open, setOpen] = useState(false);
  const [selectStatus, setSelectStatus] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState('all');
  const [startData, setStartdata] = useState('');
  const [endData, setEndData] = useState('');
  const [touchFilter, setTouchFilter] = useState();
  const [dateField, setDateField] = useState('created_at');
  const [dateRangeError, setDateRangeError] = useState('');
  const [loadingExport, setLoadingExport] = useState(false);
  const [openExport, setOpenExport] = useState(false);

  const loadData = async (overrides = {}) => {
    setLoading(true);
    const status = overrides.status !== undefined ? overrides.status : selectStatus;
    const start = overrides.startdate !== undefined ? overrides.startdate : startData;
    const end = overrides.enddate !== undefined ? overrides.enddate : endData;
    const owner = overrides.owner !== undefined ? overrides.owner : selectedOwner;
    const page = overrides.page !== undefined ? overrides.page : currentPage;
    const dateFieldParam = overrides.datefield !== undefined ? overrides.datefield : dateField;

    const resp = await api({
      method: 'GET',
      url: `/broker-policies`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitriskwl-authtoken'),
      },
      params: {
        search: overrides.search !== undefined ? overrides.search : search,
        startdate: start === '' ? undefined : start,
        enddate: end === '' ? undefined : end,
        status: Array.isArray(status) ? (status.length ? status.join(',') : undefined) : status,
        page,
        take: 10,
        owner,
        datefield: dateFieldParam,
      },
      json: true,
    });

    setPoliciesList(resp?.data?.policies);
    setTotalCount(resp?.data?.totalCount);
    setHasNextPage(resp?.data?.hasNextPage);
    setLoading(false);
    setTouchFilter(false);
    if (overrides.page !== undefined) setCurrentPage(overrides.page);
  };

  const handleLoadMore = async () => {
    if (!touchFilter) {
      const page = currentPage + 1;
      if (hasNextPage && !loadingMore) {
        setLoadingMore(true);

        const resp = await api({
          method: 'GET',
          url: `/broker-policies`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
          params: {
            search,
            startdate: startData === '' ? undefined : startData,
            enddate: endData === '' ? undefined : endData,
            status: selectStatus.length ? selectStatus.join(',') : undefined,
            page,
            take: 10,
            owner: selectedOwner,
            datefield: dateField,
          },
          json: true,
        });

        const data = policiesList;
        const ndata = data.concat(resp?.data?.policies);

        setCurrentPage(page);
        setPoliciesList(ndata);
        setHasNextPage(resp?.data?.hasNextPage);
        setLoadingMore(false);
      }
    }
  };

  const handleClear = () => {
    setSelectStatus([]);
    setSelectedOwner('all');
    setStartdata('');
    setEndData('');
    setDateRangeError('');
    setDateField('created_at');
    setCurrentPage(1);
    setTouchFilter(true);
    loadData({ status: [], owner: 'all', startdate: '', enddate: '', page: 1, datefield: 'created_at' });
  };

  const handleOpenFilter = () => {
    setDateRangeError('');
    setOpen(true);
  };

  const handleApplyFilter = () => {
    const { valid, error } = validateDateRange(startData, endData);
    if (!valid) {
      setDateRangeError(error);
      toast.error(error, { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
      return;
    }
    setDateRangeError('');
    setTouchFilter(true);
    loadData();
    setOpen(false);
  };

  const handleDateChange = (field, value) => {
    setDateRangeError('');
    if (field === 'start') setStartdata(value);
    else setEndData(value);
  };

  const parseDateForPicker = (str) => {
    if (!str || String(str).trim().length < 10) return null;
    const m = moment(str, 'DD/MM/YYYY', true);
    return m.isValid() ? m.toDate() : null;
  };

  const handleExport = async () => {
    const { valid, error: dateError } = validateDateRange(startData, endData);
    if (!valid) {
      toast.error(dateError, { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
      return;
    }

    setLoadingExport(true);
    const params = new URLSearchParams();
    params.set('owner', selectedOwner || 'all');
    if (selectStatus.length) params.set('status', selectStatus.join(','));
    if (startData && startData.length >= 10) params.set('startdate', startData);
    if (endData && endData.length >= 10) params.set('enddate', endData);
    params.set('datefield', dateField);
    const queryString = params.toString() ? `?${params.toString()}` : '';

    try {
      const resp = await api({
        method: 'GET',
        url: `/company-policies-report/stream${queryString}`,
        headers: { Authorization: Cookies.get('splitriskwl-authtoken') },
        responseType: 'blob',
      });

      const blob = resp?.data;
      if (blob && blob.size > 0) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `contratos_${new Date().toISOString().split('T')[0]}.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
        toast.success('Download iniciado!', { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
      } else {
        toast.info('Não há dados para exportar', { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
      }
      setOpenExport(false);
    } catch (error) {
      toast.error('Não foi possível exportar contratos', { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
    }
    setLoadingExport(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const statusOptions = [
    { value: 'active', label: 'Ativo' },
    { value: 'canceled', label: 'Cancelado' },
    { value: 'awaiting_cancellation', label: 'Aguardando cancelamento' },
    { value: 'expired', label: 'Expirado' },
    { value: 'awaiting_reactive', label: 'Aguardando reativação' },
  ];

  const toggleStatus = (value) => {
    setSelectStatus((prev) => (prev.includes(value) ? prev.filter((s) => s !== value) : [...prev, value]));
  };

  const renderFilterDialog = () => (
    <Dialog open={open} onClose={() => setOpen(false)} width="50%" title="Filtrar contrato">
      <Select height="30px" label="Autor do contrato" value={selectedOwner} onChange={(e) => setSelectedOwner(e.target.value)}>
        <option value="all">Todos os contratos</option>
        <option value="mypolicies">Meus contratos</option>
        <option value="teampolicies">Contratos da minha equipe</option>
      </Select>

      <div style={{ marginBottom: 16, marginTop: 12 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Status da apólice</label>
        <FormControlLabel
          control={
            <Checkbox
              checked={selectStatus.length === 0}
              indeterminate={selectStatus.length > 0 && selectStatus.length < statusOptions.length}
              onChange={() => setSelectStatus([])}
            />
          }
          label="Todos os status"
        />
        <div style={{ marginLeft: 8 }}>
          {statusOptions.map((opt) => (
            <FormControlLabel
              key={opt.value}
              control={<Checkbox checked={selectStatus.includes(opt.value)} onChange={() => toggleStatus(opt.value)} />}
              label={opt.label}
            />
          ))}
        </div>
      </div>

      <Select height="30px" label="Filtrar datas por" value={dateField} onChange={(e) => setDateField(e.target.value)}>
        <option value="created_at">Data de criação da apólice</option>
        <option value="expiration_date">Data de expiração da apólice</option>
      </Select>

      <div style={{ marginTop: 8 }}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
          <div style={{ marginBottom: 16 }}>
            <DatePicker
              label={dateField === 'expiration_date' ? 'Data inicial (expiração)' : 'Data inicial (criação)'}
              value={parseDateForPicker(startData)}
              onChange={(date) => handleDateChange('start', date ? moment(date).format('DD/MM/YYYY') : '')}
              format="dd/MM/yyyy"
              emptyLabel="DD/MM/AAAA"
              invalidDateMessage="Data inválida"
              inputVariant="outlined"
              fullWidth
              cancelLabel="Cancelar"
              okLabel="OK"
            />
          </div>
          <div style={{ marginBottom: 8 }}>
            <DatePicker
              label={dateField === 'expiration_date' ? 'Data final (expiração)' : 'Data final (criação)'}
              value={parseDateForPicker(endData)}
              onChange={(date) => handleDateChange('end', date ? moment(date).format('DD/MM/YYYY') : '')}
              format="dd/MM/yyyy"
              emptyLabel="DD/MM/AAAA"
              invalidDateMessage="Data inválida"
              inputVariant="outlined"
              fullWidth
              cancelLabel="Cancelar"
              okLabel="OK"
            />
          </div>
        </MuiPickersUtilsProvider>
        <p style={{ margin: '4px 0 0', fontSize: 12, color: '#666' }}>
          Intervalo máximo: 1 mês ({MAX_DATE_RANGE_DAYS} dias). Preencha as duas datas para filtrar por período.
        </p>
        {dateRangeError && <p style={{ margin: '4px 0 0', fontSize: 12, color: '#d32f2f' }}>{dateRangeError}</p>}
      </div>

      <ModalButton>
        <Button
          height="35px"
          outlined
          disabled={selectedOwner === 'all' && selectStatus.length === 0 && !startData && !endData && dateField === 'created_at'}
          onClick={handleClear}
        >
          Limpar filtros
        </Button>
        <Button height="35px" onClick={handleApplyFilter}>
          Aplicar alterações
        </Button>
      </ModalButton>
    </Dialog>
  );

  const renderExportDialog = () => (
    <Dialog open={openExport} onClose={() => !loadingExport && setOpenExport(false)} width="50%" title="Exportar contratos">
      <Button height="35px" style={{ margin: 0, marginTop: 30 }} onClick={handleExport} disabled={loadingExport}>
        {loadingExport ? <ReactLoading color={white} height={25} width={25} type="spin" /> : 'Exportar'}
      </Button>
    </Dialog>
  );

  return (
    <>
      <Header />
      <Container>
        {renderExportDialog()}
        {renderFilterDialog()}
        <SideMenuBroker />

        <ContentArea>
          <Div>
            <Title>MEUS CONTRATOS</Title>
            <div className="containerTitle">
              <Button title="Exportar" height="30px" style={{ marginRight: 4 }} onClick={() => setOpenExport(true)}>
                <RiFileExcel2Fill size={18} />
              </Button>
              <Button title="Filtrar" height="30px" onClick={handleOpenFilter}>
                <TiFilter size={18} />
              </Button>
              <Search
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onClear={() => {
                  setSearch('');
                  loadData();
                }}
                onConfirm={() => loadData()}
              />
            </div>
          </Div>

          <DataArea ref={scrollParent}>
            <InfiniteScroll
              loadMore={handleLoadMore}
              hasMore={hasNextPage}
              useWindow={false}
              getScrollParent={() => scrollParent?.current}
              initialLoad={false}
              style={{ width: '100%', display: 'flex' }}
              threshold={10}
            >
              <div style={{ width: '100%' }}>
                {loading && (
                  <LoadingArea>
                    <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
                  </LoadingArea>
                )}
                {!loading && policiesList?.map((policy, key) => <PolicyItem commercial key={policy.id} policy={policy} />)}
              </div>
            </InfiniteScroll>

            {!loading && !policiesList?.length && <p>Nenhum contrato encontrada</p>}
          </DataArea>
          <CountArea>
            {loadingMore && <ReactLoading color={loadingColor} height={20} width={20} type="spin" />}

            {!loadingMore && !loading && (
              <p style={{ color: primary }}>
                Mostrando {policiesList?.length} de {totalCount}
              </p>
            )}
          </CountArea>
        </ContentArea>
      </Container>
    </>
  );
}

export default Policies;
